export const INVOICE = '/api/v1/invoice-data';
export const PRINT_INVOICE = '/api/v2/invoice/print';
export const GET_CORRECTION_INVOICE = (correctionId: string) =>
    `/api/v2/child-settlements/correction/correction-file/${correctionId}`;
export const UPLOAD_CORRECTION_INVOICE = (correctionId: string) =>
    `/api/v2/child-settlements/correction/correction-file/${correctionId}`;
